import type { IncidentLog } from "@/models"
import { css } from "vite-css-in-js"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import AssetTaskedDisplay from "./AssetTasked"

interface Props {
	incident: IncidentLog
}

const listStyles = css`
	margin: 0;
	padding: 0;
	list-style: none;

	& > li {
		margin-bottom: 1.5rem;
	}
`

const AssetsTasked: ReactiveComponent<Props> = (props) => {
	return () => {
		if (props.incident.assetsTasked.length === 0) {
			return <p>No assets have been tasked</p>
		}
		return (
			<>
				<ul class={listStyles}>
					{props.incident.assetsTasked.map((asset, i) => (
						<li key={asset.id}>
							<AssetTaskedDisplay index={i} asset={asset} incidentTime={props.incident.incidentTime} />
						</li>
					))}
				</ul>
				<i style={{ marginLeft: "0.35rem" }}>
					<span style={{ marginRight: "0.125em" }}>*</span>All times given above are in UTC
				</i>
			</>
		)
	}
}

export default defineComponent(AssetsTasked, inferProps<Props>())
